import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DetentionReport from '../../Reports/DetentionReport';


const columns = [
  { key: 'containerNumber', label: 'Container Number' },
  { key: 'bookingNumber', label: 'Booking Number' },
  { key: 'size', label: 'Size' },
  { key: 'type', label: 'Type' },
  { key: 'portOfLoading', label: 'Port of Loading' },
  { key: 'portOfDischarge', label: 'Port of Discharge' },
  { key: 'currentLocation', label: 'Current Location' },
  { key: 'vesselName', label: 'Vessel Name' },
  { key: 'voyageNumber', label: 'Voyage Number' },
  { key: 'etd', label: 'ETD' },
  { key: 'eta', label: 'ETA' },
  { key: 'status', label: 'Status' },
];

// ...existing code...

const ContainerReport = () => {
  const navigate = useNavigate();
  // ...existing code...

  // Link to completed voyage report
  const handleCompletedVoyageClick = (e) => {
    e.preventDefault();
    window.location.href = '/completed-voyage-report';
  };

  return (
    <div className="container-search">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1em', marginBottom: '2em' }}>
        <a
          href="#"
          className="detentions-link"
          onClick={e => { e.preventDefault(); navigate('/detention-report'); }}
          style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer', fontSize: '1.1em' }}
        >
          Detentions Report
        </a>
        <a
          href="#"
          className="dwelltime-link"
          onClick={e => { e.preventDefault(); navigate('/container-dwell-time-report'); }}
          style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer', fontSize: '1.1em' }}
        >
          Line Container Empty Free Days Report
        </a>
        <a
          href="/completed-voyage-report"
          className="completed-voyage-link"
          onClick={handleCompletedVoyageClick}
          style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer', fontSize: '1.1em' }}
        >
          Completed Voyage Report
        </a>
      </div>
      {/* Removed modal for dwell time report, now navigates to page */}
    </div>
  );
};

export default ContainerReport;
